export default function isTouchDevice(callback: Function) {
    window.addEventListener('touchstart', function onFirstTouch() {
        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
        callback();
    }, false);
}